











































import { ref, defineComponent } from '@nuxtjs/composition-api';
import { SfImage } from '@storefront-ui/vue';

export default defineComponent({
  name: 'FullResponsePanel',
  components: { SfImage },
  props: {
    response: {
      type: String,
      default: '',
    },
    downloadLink: {
      type: String,
      default: '',
    },
  },
  setup() {
    const isOpen = ref(false);

    return {
      isOpen,
    };
  },
});
